<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Sistemos informavimas</h3>

    <v-data-table
      :headers="filteredHeaders"
      :items="filteredItemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :page.sync="page"
      :items-per-page="pageSize"
    >
      <template #[`item.sis_pranesimas`]="{ item }">
        <div class="text-cut-4">
          <span v-html="item.sis_pranesimas"></span>
        </div>
      </template>
      <template #[`item.sis_aktyvus`]="{ item }">
        <el-busena :busena="item.sis_aktyvus" taip-ne />
      </template>
      <template #[`item.vaizdavimas`]="{ item }">
        <span class="nowrap">{{ item.vaizdavimas_nuo }}</span>
        <br />
        <span class="nowrap">{{ item.vaizdavimas_iki }}</span>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action :item="item" @editItem="editItem(item)" />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-sistema-info
      :key="modalPranesimasKey"
      v-model="showPranesimas"
      :item="modalPranesimas"
      @savedData="savedPranesimas"
      @canceledData="canceledPranesimas"
    />
  </v-container>
</template>

<script>
import ModalSistemaInfo from '../modals/ModalSistemaInfo'

export default {
  name: 'AdminSistemaInfo',
  components: { ModalSistemaInfo },
  data() {
    return {
      pageloading: true,
      loading: true,
      sistemos_informavimai: [],
      search: null,
      itemsPerPageOptions: [20, 50, 100],
      pageSize: 20,
      page: 1,
      seeder: null,
      seederInput: null,
      showSeeder: false,
      modalPranesimas: {},
      modalPranesimasReadonly: false,
      showPranesimas: false,
      modalPranesimasRefresh: 0,
      showDelete: false,
      modalDeleteVardas: null,
      modalDeleteItem: null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Vieta',
          align: 'start',
          sortable: false,
          value: 'vieta',
          width: 200,
        },
        {
          text: 'Pranešimas',
          align: 'start',
          sortable: false,
          value: 'sis_pranesimas',
        },
        {
          text: 'Aktyvus',
          align: 'center',
          value: 'sis_aktyvus',
          width: 100,
        },
        {
          text: 'Vaizdavimas',
          align: 'right',
          value: 'vaizdavimas',
          width: 150,
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 100,
        },
      ]
    },
    isAprasymas() {
      return this.grupe === 'aprasymas'
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filteredItemsList() {
      return this.itemsList.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.sistemos_informavimai.map(item => {
        item.vieta =
          item.sis_sistema_kodas === 'darbo_vieta' ? 'Darbo vieta' : 'Savitarna'

        item.vaizdavimas_nuo = 'nuo -'
        item.vaizdavimas_iki = 'iki -'

        if (item.sis_galioja_nuo) {
          item.vaizdavimas_nuo = `nuo ${item.sis_galioja_nuo_diena} ${item.sis_galioja_nuo_laikas}`
        }
        if (item.sis_galioja_iki) {
          item.vaizdavimas_iki = `iki ${item.sis_galioja_iki_diena} ${item.sis_galioja_iki_laikas}`
        }

        item.canEdit = true
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isSearch() {
      return this.search != null && this.search.length > 0
    },
    showSeederButton() {
      return (
        process.env.VUE_APP_LOCAL === 'local' ||
        process.env.VUE_APP_LOCAL === 'develop'
      )
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    modalPranesimasKey() {
      return 'tooltip-' + this.modalPranesimasRefresh
    },
    deleteTile() {
      return this.isAprasymas ? 'Šalinti aprašymą' : 'Šalinti patartį (tooltip)'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`admin/sistemos-informavimas`)
        .then(res => {
          this.sistemos_informavimai = res.data.sistemos_informavimai
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    addItem() {
      this.openTooltip(null)
    },
    editItem(item) {
      this.openModal(item)
    },
    openModal(item) {
      if (item) {
        this.modalPranesimas = {
          ...item,
        }
      } else {
        this.modalPranesimas = {}
      }

      this.modalPranesimasRefresh++
      this.showPranesimas = true
    },
    savedPranesimas(item) {
      this.saveData(item)
    },
    canceledPranesimas() {
      //
    },

    saveData(item) {
      const data = {
        sis_aktyvus: item.sis_aktyvus,
        sis_pranesimas: item.sis_pranesimas,
        sis_galioja_nuo_diena: item.sis_galioja_nuo_diena,
        sis_galioja_nuo_laikas: item.sis_galioja_nuo_laikas,
        sis_galioja_iki_diena: item.sis_galioja_iki_diena,
        sis_galioja_iki_laikas: item.sis_galioja_iki_laikas,
      }

      this.$axios
        .post(`admin/sistemos-informavimas/${item.sis_id}`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.showPranesimas = false
          this.getData()
        })
    },
  },
}
</script>
